import styled from "styled-components";
import { theme } from "../../constants/StyledComponents";

export const StyledCollaboratorProfileCard = styled.div`
  display: flex;
  flex-direction: column;
  justify-content: space-between;
  box-shadow: 0px 2px 8px 0px rgba(74, 74, 79, 0.08);
  border-radius: ${theme.variables.border_radius_2};
  background-color: ${theme.colors.white};
  padding: 24px;
  box-sizing: border-box;
  width: 100%;
  overflow: hidden;
  min-height: 200px;

  & .top-content {
    display: flex;
    flex-direction: column;
    flex-grow: 1;
  }

  & .bottom-content {
    display: flex;
    flex-direction: row;
    flex-wrap: wrap;
    justify-content: space-between;
    align-items: start;
    flex-grow: 0;
  }

  & .card-header {
    display: flex;
    flex-direction: row;
    flex-wrap: wrap;
    justify-content: space-between;
    align-items: start;
    row-gap: 12px;
    column-gap: 2px;
    overflow-wrap: anywhere;
    margin-bottom: 20px;

    & > span {
      max-height: 80px;
      overflow: hidden;
    }

    & div > input {
      width: 40px;
    }
  }

  & .card-row {
    display: flex;
    flex-direction: row;
    justify-content: start;
    align-items: center;
    column-gap: 12px;
    row-gap: 0px;
    overflow-wrap: anywhere;

    & > span {
      max-height: 80px;
      overflow: hidden;
    }
  }
`;

type StyledRotateSvgProps = {
  $isNegative: boolean;
};

export const StyledRotateSvg = styled.div<StyledRotateSvgProps>`
  background-color: ${({ $isNegative }) =>
    $isNegative ? `${theme.colors.red_2}` : `${theme.colors.green_2}`};
  border-radius: 100px;
  width: 20px;
  height: 20px;
  align-items: center;
  display: flex;
  justify-content: center;

  & > svg {
    width: 15px;
    transform: ${({ $isNegative }) =>
      $isNegative ? "rotate(45deg)" : "rotate(-135deg)"};
  }

  & > svg path {
    stroke: ${({ $isNegative }) =>
      $isNegative ? `${theme.colors.red_1}` : `${theme.colors.green}`};
  }
`;
